import * as React from 'react';
import ConnectedThemeProvider from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider';
import merge from 'lodash/merge';
import { blue, disabledGreen, green } from './Constants/Colors';

const customTheme = {
  overrides: {
    MainButton: {
      root: {
        backgroundColor: blue,
        borderRadius: '30px',
      },
      label:{
        textTransform: 'uppercase'
      }
    },
    MuiSelect: {
      icon: {
        color: green
      }
    },
    FullScreenView: {
      buttonIcon: {
        background: "-webkit-radial-gradient(circle, rgba(15,87,141,1) 11%, rgba(139,199,64,1) 20%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        padding: '8px'
      },
      button: {
        border: `${blue} solid 1px`,
        borderRadius: '30px',
        textTransform: 'uppercase'
      }
    },
    PdfDownload:{
      activeButton:{
        backgroundColor: blue,
      }
    },
    CallToAction:{
      icon:{
        color: green
      }
    },
    Thumbnail:{
      activeDotMode:{
        backgroundColor: green
      },
      inactiveDotMode: {
        backgroundColor: disabledGreen
      }
    },
      ColorPalettes: {
      formControlCustomColor: {
        visibility: 'hidden',
        paddingTop: '0px !important',
        height: '0px ',
      },
    },
  },
};

const overrideTheme = (theme) => {
  merge(theme.overrides, {});
};

export default ({ children }) => (
  <ConnectedThemeProvider customTheme={customTheme} withTheme={overrideTheme}>
    {children}
  </ConnectedThemeProvider>
);
